import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  school: belongsTo(),
  students: hasMany(),
  teachers: hasMany(),
})
